import {Organiser} from "../organizer";
import {EventItem} from "../event-item";
import {LeagueStatus} from "./league-status";

export class League {
  id?: number;
  organiser?: Organiser;
  name?: string;
  nameEng?: string;
  nameIta?: string;
  nameSlo?: string;
  status?: LeagueStatus;
  start?: Date;
  end?: Date;
  image?: string;
  imageIcon?: string;
  imageMini?: string;
  imageSmall?: string;
  imageMedium?: string;
  created?: Date;
  modified?: Date;
  defaultLanguage?: number;
  extraLanguages?: number[];
  description?: string;
  rules?: string;
  events?: EventItem[];
  sportId?: number;
  countries?: number[];
  maxNumberOfEvents?: number;
}


